export const ELEMENT_COLORS = {
  Wood: { color: "#5cb87a", glow: "rgba(92, 184, 122, 0.35)", symbol: "木" },
  Fire: { color: "#e86a4f", glow: "rgba(232, 106, 79, 0.35)", symbol: "火" },
  Earth: { color: "#d4a055", glow: "rgba(212, 160, 85, 0.35)", symbol: "土" },
  Metal: { color: "#a8b8c8", glow: "rgba(168, 184, 200, 0.35)", symbol: "金" },
  Water: { color: "#4a9fd4", glow: "rgba(74, 159, 212, 0.35)", symbol: "水" },
};

const ANIMAL_EMOJI = {
  Rat: "🐀",
  Ox: "🐂",
  Tiger: "🐯",
  Rabbit: "🐇",
  Dragon: "🐉",
  Snake: "🐍",
  Horse: "🐴",
  Goat: "🐑",
  Monkey: "🐒",
  Rooster: "🐓",
  Dog: "🐕",
  Pig: "🐖",
};

const ELEMENT_SLUG = {
  Wood: "wood",
  Fire: "fire",
  Earth: "earth",
  Metal: "metal",
  Water: "water",
};

export function animalEmoji(animal, locale = "en") {
  if (!animal) return "";
  if (locale === "vi" && animal === "Rabbit") return "🐈";
  return ANIMAL_EMOJI[animal] || "";
}

export function formatAnimal(animal, locale = "en") {
  const emoji = animalEmoji(animal, locale);
  return emoji ? `${emoji} ${animal}` : animal || "";
}

export function elementColor(element) {
  return ELEMENT_COLORS[element] || ELEMENT_COLORS.Earth;
}

/** Semantic badge colors for combined element tiers (not elemental hues). */
export function elementTierColor(tier, { secondary = "#5ef0d8" } = {}) {
  switch (tier) {
    case "deficient":
      return "#ff9ab0";
    case "lean":
      return "#e8b86d";
    case "balanced":
      return "#8fd4b4";
    case "strong":
      return secondary;
    case "excess":
      return "#e86a4f";
    default:
      return "#9aa3b8";
  }
}

export function elementLabel(element, t) {
  const slug = ELEMENT_SLUG[element];
  if (!slug || !t) return element;
  const key = `cz_element_${slug}`;
  const label = t(key);
  return label && label !== key ? label : element;
}

export function chartSideLabel(partners, side, t) {
  const custom = partners?.[side]?.label;
  if (custom) return custom;
  return t(side === "a" ? "couple_match_chart_first" : "couple_match_chart_second");
}
